<template>
  <v-app>
    <!-- Sidebar -->
    <v-navigation-drawer app width="256" class="print:hidden">
      <Sidebar />
    </v-navigation-drawer>

    <!-- Top App Bar -->
    <v-app-bar
      elevation="0"
      app
      color="white"
      style="
        background: url('/top-background.png') no-repeat;
        background-position: top right;
        background-size: 100% 152%;
      "
    >
      <Navbar />
    </v-app-bar>

    <!-- Main View -->
    <v-main>
      <router-view />
      <loading />
    </v-main>
  </v-app>
</template>

<script>
import Sidebar from '@/components/Sidebar';
import Navbar from '@/components/NavBar';
import Loading from '@/components/Loading.vue';
export default {
  name: 'App',
  components: {
    Sidebar,
    Navbar,
    Loading,
  },
};
</script>
